const fi = {
  pleaseEnterUsername: "Anna käyttäjänimi",
  cannotFriendYourself: "Et voi lähettää kaveripyyntöä itsellesi.",
  friendRequestSent: "Kaveripyyntö lähetetty!",
  failedToSendRequest: "Pyynnön lähettäminen epäonnistui",
  linkCopied: "Linkki kopioitu leikepöydälle!",
  backToInvites: "Takaisin kutsuihin",
  sendFriendRequestByUsername: "Lähetä kaveripyyntö käyttäjänimellä",
  enterUsername: "Anna käyttäjänimi",
  send: "Lähetä",
  yourInviteQrCode: "Kutsusi QR-koodi",
  inviteLink: "Kutsulinkki",
  scanQrOrUseLink: "Skannaa tämä QR-koodi tai käytä tätä linkkiä lähettääksesi kaveripyynnön",
  copyInviteLink: "Kopioi kutsulinkki",
  goToItem: "Siirry kohteeseen",
  verificationEmailSent: "Vahvistussähköposti lähetetty! Tarkista saapuneet viestisi.",
  verificationEmailFailed: "Vahvistussähköpostin lähettäminen epäonnistui. Yritä uudelleen.",
  verifyYourEmail: "Vahvista sähköpostiosoitteesi",
  verifyEmailInstructions: "Vahvista sähköpostiosoitteesi päästäksesi tilillesi. Tarkista saapuneet viestisi vahvistuslinkin löytämiseksi.",
  sending: "Lähetetään...",
  resendVerificationEmail: "Lähetä vahvistussähköposti uudelleen",
  login: "Kirjaudu sisään",
  register: "Rekisteröidy",
  home: "Etusivu",
  calendar: "Kalenteri",
  friends: "Ystävät",
  profile: "Profiili",
  logout: "Kirjaudu ulos",
  loading: "Ladataan...",
  language: "Kieli",
  calendarSelectPlaceSuggestion: "Valitse paikka ehdotuksista, jotta koordinaatit voidaan liittää mukaan.",
  calendarSelectDateAndTime: "Valitse päivämäärä ja aika.",
  calendarPositiveDuration: "Anna positiivinen kesto.",
  calendarFutureDateRequired: "Tapahtuman päivämäärän ja ajan on oltava tulevaisuudessa.",
  calendarCreateEventFailed: "Tapahtuman luominen epäonnistui. Yritä uudelleen.",
  cancel: "Peruuta",
  createNewEvent: "Luo uusi tapahtuma",
  week: "Viikko",
  month: "Kuukausi",
  eventTitle: "Otsikko",
  date: "Päivämäärä",
  time: "Aika",
  duration: "Kesto",
  endsAt: "Päättyy",
  place: "Paikka",
  searchForPlace: "Etsi paikkaa",
  placeSearchTip: "Vinkki: aloita kirjoittaminen ja valitse tulos liittääksesi koordinaatit.",
  description: "Kuvaus",
  createEvent: "Luo tapahtuma",
  today: "Tänään",
  previousMonth: "Edellinen kuukausi",
  nextMonth: "Seuraava kuukausi",
  previous: "Edellinen",
  next: "Seuraava",
  mondayShort: "Ma",
  tuesdayShort: "Ti",
  wednesdayShort: "Ke",
  thursdayShort: "To",
  fridayShort: "Pe",
  saturdayShort: "La",
  sundayShort: "Su",
  more: "lisää",
  mustRespondWillBeforeReposting: "Sinun täytyy vastata \"Osallistun\" ennen uudelleenjulkaisua",
  event: "Tapahtuma",
  backToCalendar: "Takaisin kalenteriin",
  addToGoogleCalendar: "Lisää Google-kalenteriin",
  when: "Milloin",
  where: "Missä",
  openLocationInGoogleMaps: "Avaa sijainti Google Mapsissa",
  hosts: "Järjestäjät",
  yourResponse: "Vastauksesi",
  currentResponse: "Nykyinen vastaus",
  response_will: "Osallistun",
  response_might: "Saatan osallistua",
  response_wont: "En osallistu",
  willRunIntoYou: "Poikkean paikalle",
  mightDropBy: "Saatan poiketa",
  wontCome: "En tule",
  repostToMyFriends: "Jaa uudelleen ystävilleni",
  responses: "Vastaukset",
  willAttend: "Osallistuu",
  reposted: "Jaettu uudelleen",
  mightAttend: "Saattaa osallistua",
  cancelEvent: "Peruuta tapahtuma",
  cancellationEmailNoticeBefore: "Osallistumisensa vahvistaneet henkilöt",
  cancellationEmailNoticeAfter: "saavat sähköpostin tapahtuman peruutuksesta.",
  optionalCancellationMessage: "Valinnainen viesti osallistujille (enintään 1000 merkkiä)",
  confirmCancelEvent: "Vahvista tapahtuman peruutus",
  clear: "Tyhjennä",
  confirmCancellation: "Vahvista peruutus",
  confirmCancellationMessage: "Haluatko varmasti peruuttaa tämän tapahtuman? Tämä ilmoittaa vahvistetuille osallistujille ja poistaa tapahtuman.",
  eventCancelledNotified: "Tapahtuma peruttu. Ilmoitettu",
  attendees: "osallistujalle",
  failedToCancelEvent: "Tapahtuman peruminen epäonnistui",
  back: "Takaisin",
  cancelled: "Peruttu",
  ok: "OK",
  forgotPassword: "Unohtuiko salasana",
  email: "Sähköposti",
  passwordResetLinkSent: "Jos tili on olemassa, salasanan palautuslinkki on lähetetty.",
  passwordResetRequestFailed: "Salasanan palautuspyyntö epäonnistui.",
  sendResetLink: "Lähetä palautuslinkki",
  addFriend: "Lisää ystävä",
  incomingRequests: "Saapuvat pyynnöt",
  accept: "Hyväksy",
  deny: "Hylkää",
  myFriends: "Ystäväni",
  noFriendsYet: "Ei vielä ystäviä. Aloita lisäämällä niitä!",
  seeProfile: "Näytä profiili",
  noEventsToRespondTo: "Ei tapahtumia, joihin vastata",
  allCaughtUp: "Olet ajan tasalla. Tarkista myöhemmin ystäviesi uudet tapahtumat.",
  events: "Tapahtumat",
  unknown: "Tuntematon",
  noDescriptionProvided: "Kuvausta ei annettu.",
  will: "Kyllä",
  maybe: "Ehkä",
  wont: "Ei",
  userNotFound: "Käyttäjää ei löytynyt",
  friendRequestSentSuccessfully: "Kaveripyyntö lähetetty onnistuneesti!",
  friendInvitation: "Kaverikutsu",
  sendFriendRequest: "Lähetä kaveripyyntö",
  loginToSendFriendRequest: "Kirjaudu sisään lähettääksesi kaveripyynnön",
  chooseLanguage: "Valitse kieli",
  invalidCredentials: "Virheelliset tunnistetiedot. Yritä uudelleen.",
  username: "Käyttäjänimi",
  password: "Salasana",
  forgotPasswordQuestion: "Unohtuiko salasana?",
  dontHaveAccount: "Eikö sinulla ole tiliä?",
  registerHere: "Rekisteröidy täällä",
  invalidProfilePhotoType: "Virheellinen tiedostotyyppi. Lataa JPEG-, PNG-, GIF- tai WebP-kuva.",
  invalidFileExtension: "Virheellinen tiedostopääte",
  allowedExtensions: "Sallitut",
  fileTooLarge: "Tiedosto on liian suuri",
  maximumFileSize: "Enimmäiskoko",
  profilePhotoRemoved: "Profiilikuva poistettu.",
  failedToRemoveProfilePhoto: "Profiilikuvan poistaminen epäonnistui",
  profileUpdatedSuccessfully: "Profiili päivitetty onnistuneesti!",
  failedToUpdateProfile: "Profiilin päivittäminen epäonnistui",
  privateEmailExplanation: "Vain sinä näet sähköpostiosoitteesi välttääksesi ei-toivotut yhteydenotot palvelun ulkopuolella",
  yourEmailIsPrivate: "Sähköpostiosoitteesi on yksityinen.",
  profilePhoto: "Profiilikuva",
  removePhoto: "Poista kuva",
  firstName: "Etunimi",
  lastName: "Sukunimi",
  tellPeopleAboutYourself: "Kerro itsestäsi",
  whereToContactMe: "Miten minuun saa yhteyden",
  contactInfoPlaceholder: "Instagram: myUsername\nDiscord: myDiscord",
  save: "Tallenna",
  notSet: "Ei asetettu",
  editProfile: "Muokkaa profiilia",
  imageToCrop: "Rajattava kuva",
  zoom: "Zoomaus",
  usePhoto: "Käytä kuvaa",
  name: "Nimi",
  whereToContact: "Yhteystiedot",
  removeFriendship: "Poista ystävyys",
  confirmRemoveFriend: "Vahvista ystävän poistaminen",
  confirmRemoveFriendBefore: "Haluatko varmasti poistaa käyttäjän",
  confirmRemoveFriendAfter: "ystävälistaltasi?",
  friendRemoved: "Ystävä poistettu.",
  failedToRemoveFriend: "Ystävän poistaminen epäonnistui.",
  confirmRemove: "Vahvista poisto",
  error: "Virhe",
  removed: "Poistettu",
  passwordsDoNotMatch: "Salasanat eivät täsmää",
  registrationFailed: "Rekisteröinti epäonnistui. Yritä uudelleen.",
  confirmPassword: "Vahvista salasana",
  alreadyHaveAccount: "Onko sinulla jo tili?",
  loginHere: "Kirjaudu sisään täällä",
  passwordResetSuccessfully: "Salasana palautettu onnistuneesti.",
  failedToResetPassword: "Salasanan palautus epäonnistui.",
  resetPassword: "Palauta salasana",
  newPassword: "Uusi salasana",
  confirmNewPassword: "Vahvista uusi salasana",
  setNewPassword: "Aseta uusi salasana",
  emailVerifiedSuccessfully: "Sähköposti vahvistettu onnistuneesti!",
  emailVerificationFailed: "Vahvistus epäonnistui. Linkki voi olla virheellinen tai vanhentunut.",
  verifying: "Vahvistetaan...",
  verified: "Vahvistettu!",
  redirectingToHome: "Ohjataan etusivulle...",
  verificationFailed: "Vahvistus epäonnistui",
  goToHome: "Siirry etusivulle",
  about: "Tietoja",
  aboutConceptTitle: "Konsepti",
  aboutCreatorIntroduction: "Hei, olen Crypt0, kiipeilijä ja Run Into Me -palvelun tekijä.",
  aboutCreatorStory: "Tein sivuston, koska olen sosiaalinen ja käytin liikaa aikaa yhteisten kiipeilykertojen järjestämiseen.",
  aboutPlanningProblem: "Halusin kertoa kaikille yhtä aikaa, milloin ja missä kiipeilen, ilman muodollista kutsua.",
  aboutDeveloperSolution: "Sitten muistin olevani kehittäjä ja voivani tehdä ratkaisun itse.",
  aboutWelcome: "Tervetuloa Run Into Me -palveluun, jossa kerrot ystävillesi toiminnasta, johon he voivat liittyä ilman paineita.",
  aboutCallToAction: "Julkaise täällä seuraava tekeminen, joka on hauskempaa yhdessä!",
  aboutTutorialTitle: "Opas",
  aboutCalendarCreateEvent: "Kalenterinäkymässä voit myös luoda uuden tapahtuman.",
  aboutEventColorsIntroduction: "Värit osoittavat osallistumistilasi:",
  aboutColorGold: "Kultainen",
  aboutColorGoldDescription: "Järjestät tapahtuman.",
  aboutColorGreen: "Vihreä",
  aboutColorGreenDescription: "Osallistut tapahtumaan.",
  aboutColorOrange: "Oranssi",
  aboutColorOrangeDescription: "Vastasit ”ehkä”.",
  aboutColorBlue: "Sininen",
  aboutColorBlueDescription: "Et ole vielä vastannut.",
  aboutColorGray: "Harmaa",
  aboutColorGrayDescription: "Hylkäsit kutsun.",
  aboutCalendarEventDetails: "Avaa tapahtuma nähdäksesi tiedot ja vastataksesi.",
  aboutFriendPageTitle: "Ystäväsivu",
  aboutFriendPageDescription: "Anna käyttäjänimi tai lähetä kutsulinkki / QR-koodi.",
  aboutHomePageTitle: "Etusivu",
  aboutHomePageDescription: "Selaa tulevia tapahtumia ja ilmoita osallistumisestasi.",
  aboutRepostScreenTitle: "Uudelleenjulkaisunäkymä",
  aboutGoogleCalendarDescription: "Lisää tapahtuma Google Kalenteriin tällä painikkeella.",
  aboutRepostDescription: "Vahvistettuasi osallistumisen voit julkaista tapahtuman ystävillesi.",
};

export default fi;